import * as types from './mutation-type'
import { API_STATES } from '@/helpers'
// import { try } from 'bluebird'


const mutations = {
  [types.POST_CREDIT_CARD_BEGIN](state) {
    state.creditCardSuccessState = API_STATES.REQUEST_PENDING
  },
  /* eslint-disable camelcase */
  [types.POST_CREDIT_CARD_SUCCESS](state, { message, stripeToken:{ card:{ exp_month, exp_year,last4 } }, rootState }) {
    state.creditCardErrorState = null
    state.creditCardSuccessState = API_STATES.REQUEST_SUCCESS 
    state.billingSuccessMessage = message
    rootState.app.Company.expiration_date = `${exp_month}${exp_year}`
    rootState.app.Company.last_four=`${last4}`    
  },
  [types.POST_CREDIT_CARD_ERROR](state, err) {
    state.creditCardErrorState = err
    state.creditCardSuccessState = API_STATES.REQUEST_ERROR
  },

  [types.POST_BILLING_INVOICE_BEGIN](state) {
    state.billingInvoiceSuccessState = API_STATES.REQUEST_PENDING
  },
  [types.POST_BILLING_INVOICE_SUCCESS](state, { message }) {
    state.billingInvoiceErrorState = null
    state.billingInvoiceSuccessState = API_STATES.REQUEST_SUCCESS 
    state.postBillingInvoiceSuccessMessage = message
  },
  [types.POST_BILLING_INVOICE_ERROR](state, err) {
    state.billingInvoiceErrorState = err
    state.billingInvoiceSuccessState = API_STATES.REQUEST_ERROR
  },

  [types.GET_BILLING_INVOICE_BEGIN](state) {
    state.billingGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_BILLING_INVOICE_SUCCESS](state, invoicedata) {
    state.billingsGetError = null;
    state.invoicedata = invoicedata;
    state.billingGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_BILLING_INVOICE_ERROR](state, err) {
    state.billingGetState = API_STATES.REQUEST_ERROR;
    state.billingsGetError = err;
  },

  [types.POST_BILLING_PACKAGE_BEGIN](state) {
    state.packageSuccessState = API_STATES.REQUEST_PENDING;
  },
  [types.POST_BILLING_PACKAGE_SUCCESS](state){
    state.packageErrorState = null;
    state.packageSuccessState = API_STATES.REQUEST_SUCCESS;
  },
  [types.POST_BILLING_PACKAGE_ERROR](state, err) {
    state.packageSuccessState = API_STATES.REQUEST_ERROR;
    state.packageErrorState = err;
  },
  
  [types.GET_NEWBILLING_COUNT_BEGIN](state) {
    state.billingSuccessCountGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_NEWBILLING_COUNT_SUCCESS](state, data ){    
    state.billingCountGetErrorState = null;
    state.billingCount = data.totalPrice
    state.billingDays = data.totalDays
    state.billingSuccessCountGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_NEWBILLING_COUNT_ERROR](state, err) {
   
    state.billingSuccessCountGetState = API_STATES.REQUEST_ERROR;
    state.billingCountGetErrorState = err;
  },
  
  [types.CANCEL_PACKAGE_BEGIN](state) {
    state.packageCancellationState = API_STATES.REQUEST_PENDING;
  },
  [types.CANCEL_PACKAGE_SUCCESS](state){
    state.packageCancellationState = API_STATES.REQUEST_SUCCESS
    state.packageCancellationError = null
  },
  [types.CANCEL_PACKAGE_ERROR](state, err) {
    state.packageCancellationState = API_STATES.REQUEST_ERROR
    state.packageCancellationError = err
  },

  [types.REACTIVATE_PACKAGE_BEGIN](state) {
    state.packageReactivateState = API_STATES.REQUEST_PENDING;
  },
  [types.REACTIVATE_PACKAGE_SUCCESS](state){
    state.packageReactivateState = API_STATES.REQUEST_SUCCESS
    state.packageReactivateError = null
  },
  [types.REACTIVATE_PACKAGE_ERROR](state, err) {
    state.packageReactivateState = API_STATES.REQUEST_ERROR
    state.packageReactivateError = err
  },
  [types.TOGGLE_REACTIVATE_SUBSCRIPTION_POPUP](state, isShow){
    state.showPopup = isShow
  },
  [types.GET_BILLING_TYPE](state, packageType){
    state.packageType = packageType.toLowerCase()
  },
  [types.REMOVE_PACKAGE_SUBSCRIPTION_BEGIN](state) {
    state.packageRemoveState = API_STATES.REQUEST_PENDING;
  },
  [types.REMOVE_PACKAGE_SUBSCRIPTION_SUCCESS](state){
    state.packageRemoveState = API_STATES.REQUEST_SUCCESS
    state.packageRemoveError = null
  },
  [types.REMOVE_PACKAGE_SUBSCRIPTION_ERROR](state, err) {
    state.packageRemoveState = API_STATES.REQUEST_ERROR
    state.packageRemoveError = err
  },
}

export default mutations